<div class="main-container" *ngIf="userId && userId.length > 0">
  <fm-header *ngIf="!hasRoute('externalFlag') && !hasRoute('print') " [firstLevelMenu]="levelOneMenu"
             [userName]="userName" [profileMenuItems]="$any(items)"
             [alignMenuRight]="true" [smallLogo]="false" [noFixed]="false" class="u-height-45">
  </fm-header>
  <fm-header *ngIf="hasRoute('externalFlag') && !hasRoute('print')" [firstLevelMenu]="externalErrorMenu"
             [alignMenuRight]="true" [smallLogo]="false" [noFixed]="false" class="u-height-45">
  </fm-header>

<div class="container-fluid">
  <div class="row"  >
    <div *ngIf=" !hasRoute('print')  " class="col-3 collapse show d-md-flex bg-light pt-2 ps-0
                sidemenu-container" id="sidebar" >

      <ul class="nav flex-column flex-nowrap overflow-hidden">


        <div *ngIf="systemIndicator==='true'">
        <li class="nav-item"  *ngIf="!hasRoute('contactInfo')">
          <a class="nav-link text-truncate nav-menu-item" href="#" routerLink="/mainMenu" (click)="mainMenuNav()"><i class="fa fa-home"></i>
            <span class="d-none d-sm-inline " id="mainMenu">Main Menu</span></a>
        </li>

        <!-- Reverse Mortgage -->
          <div *ngIf="rmIndicator==='true' && (servicingIndicator ==='true' || deliveryIndicator=== 'true')">
        <li  class="nav-item" *ngIf="!hasRoute('contactInfo') && (rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate || rmExtDelView || rmExtDelUpdate)">
          <a class="nav-link collapsed text-truncate nav-menu-item" data-bs-target="#submenu1" data-bs-toggle="collapse"
            href="#submenu1" (click)="reverseMortgageNav()" routerLink="/reverseMortgage"><i class="fa fa-table"></i>
            <span class="d-none d-sm-inline" id="reverseMortgage">Reverse Mortgage</span>
          </a>
          <div aria-expanded="false" class="collapse" id="submenu1">
            <ul class="flex-column ps-2 nav">

              <li  class="nav-item" *ngIf="((rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtDelView || rmExtDelUpdate) && deliveryIndicator==='true')">
                <a class="nav-link  text-truncate py-1 nav-menu-item" data-bs-target="#submenu1sub1"
                  href="#submenu1sub1" routerLink="/reverseMortgage">
                  <span id="delivery"> - Delivery</span>
                </a>
                <div aria-expanded="false" class="collapse show" id="submenu1sub1">
                  <ul class="flex-column nav ps-4">
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtDelView || rmExtDelUpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/searchupdateloan" id="searchupdateloan">
                        <i class="fa fa-fw fa-clock-o " ></i> - Search & Update Loans </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtDelView || rmExtDelUpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/deliveryViewPurchaseAdvice" id="deliveryViewPurchaseAdvice">
                        <i class="fa fa-fw fa-compass" ></i> - View Purchase Advice </a>
                    </li>
                    <li class="nav-item" *ngIf="rmExtDelUpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/contactInfo" id="contactInfo">
                        <i class="fa fa-fw fa-compass" ></i> - Contact Info </a>
                    </li>
                  </ul>
                </div>
              </li>

              <li class="nav-item" *ngIf="((rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate) && servicingIndicator ==='true')">
                <a class="nav-link text-truncate py-1 nav-menu-item " data-bs-target="#submenu1sub2"
                  href="#submenu1sub2" routerLink="/reverseMortgage">
                  <span id="accountingReporting" > - Accounting / Reporting </span></a>
                <div aria-expanded="false" class="collapse show" id="submenu1sub2">
                  <ul class="flex-column nav ps-4">
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/queryLoans" id="queryLoans">
                        <i class="fa fa-fw fa-clock-o"></i> - Query Loans </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/queryTransactions" id="queryTransactions">
                        <i class="fa fa-fw fa-dashboard"></i> - Query Transactions </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/queryServicerTransfers" id="queryServicerTransfers">
                        <i class="fa fa-fw fa-bar-chart"></i> - Query Servicer Transfers </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntUpdate || isAdmin || isDeveloper || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" id="performTransactions" routerLink="/transactions">
                        <i class="fa fa-fw fa-compass"></i> - Perform Transactions </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/accountingReports" id="accountingReports">
                        <i class="fa fa-fw facompass"></i> - Reports </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/accountingViewPurchaseAdvice" id="accountingViewPurchaseAdvice">
                        <i class="fa fa-fw fa-compass"></i> - View Purchase Advice </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntUpdate || isAdmin || isDeveloper || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/submitTrialBalance" id="submitTrialBalance">
                        <i class="fa fa-fw fa-compass"></i> - Submit Trial Balance </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntView || rmIntUpdate || isAdmin || isDeveloper || rmExtSerView || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" routerLink="/viewtransmission" id="accountingViewTransmission">
                        <i class="fa fa-fw fa-compass"></i> - View Transmission </a>
                    </li>
                    <li class="nav-item" *ngIf="rmIntUpdate || isAdmin || isDeveloper || rmExtSerpdate">
                      <a class="nav-link p-1 text-truncate nav-menu-item" href="#" id="uploadFile" routerLink="/uploadFile">
                        <i class="fa fa-fw fa-compass"></i> - Upload File </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </li>
        </div>
        <!-- Admin -->
        <li  class="nav-item" *ngIf="!hasRoute('contactInfo') && (isAdmin || isDeveloper || rmIntUpdate)">
          <a class="nav-link collapsed text-truncate nav-menu-item" data-bs-target="#submenu3" data-bs-toggle="collapse"
            href="#submenu3" routerLink="/admin" (click)="adminNav()"><i class="fa fa-table"></i>
            <span class="d-none d-sm-inline " id="admin">Admin</span>
          </a>
          <div aria-expanded="false" class="collapse" id="submenu3">
            <ul class="flex-column ps-2 nav">

              <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/postPurchaseAdj"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline " id="postPurchaseAdj">- Post Purchase Adjustments</span></a>
              </li>

              <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/holiday"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline " id="holiday"> - Holiday</span></a>
              </li>

              <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/adminReports"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline " id="adminReports"> - Reports</span></a>
              </li>

              <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/updateSystemAttributes"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline " id="adminUpdateSystemAttributes"> - Update System Attributes</span></a>
              </li>

            </ul>
          </div>
        </li>
        <br /><br /><br />

        </div>
        <!-- Developer -->

        <li class="nav-item" *ngIf="!hasRoute('contactInfo') && isDeveloper">
          <a class="nav-link collapsed text-truncate nav-menu-item" data-bs-target="#submenu5" data-bs-toggle="collapse"
            href="#submenu1" routerLink="" (click)="developerNav()"><i class="fa fa-table"></i>
            <span class="d-none d-sm-inline " id="Developer">Developer</span>
          </a>
          <div aria-expanded="false" class="collapse" id="submenu5">
            <ul class="flex-column ps-2 nav">

              <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/updateDeveloperAttributes"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline " id="updateDeveloperAttributes"> - Update System Attributes </span></a>
              </li>

              <!-- NOT REQUIRED <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/mainMenu"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline "> - Log Level </span></a>
              </li> -->

              <!--Uncomment if required <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/mainMenu"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline "> - Health Check Crystal Server </span></a>
              </li> -->

              <!-- NOT REQUIRED <li class="nav-item">
                <a class="nav-link text-truncate py-1 nav-menu-item" href="#" routerLink="/mainMenu"><i
                    class="fa fa-home"></i>
                  <span class="d-none d-sm-inline "> - Version Information </span></a>
              </li> -->

            </ul>
          </div>
        </li>

      </ul>
    </div>

    <div [ngClass]="gridLayoutBody" class="ebq-right-content">

      <div *ngIf="header && !hasRoute('print')" class="u-mt-11">
        <span class="eboutique-header glypha-font"id="mainHeader" >
							eBoutique
						</span>
        <img [src]="'../assets/images/EMBHeaderDividr.gif'" class="headerimg" height="1" width="600">
      </div>
      <router-outlet></router-outlet>

      <app-loader></app-loader>

    </div>
  </div>
</div>

  <fm-footer class="mt-footer u-footer-margin">
    &copy;2007-2023 Fannie Mae.&nbsp;All Rights Reserved. </fm-footer>
</div>
